import { styled } from 'styled-components';

const Hr = styled.hr`
  display: block;
  border: none;
  margin: 0;
  padding: 0;
  height: ${({ theme }) => theme.designTokens.dividerSize};
  background: ${({ theme }) => theme.designTokens.dividerColor};
`;

export const Styled = {
  Hr,
};
